import { buildUrl } from '@/common-utils/functions/restUtils';
import { client } from '@/common-utils/libraries/axios/axios';
import NotifRulesFields from '../../fields/notifRulesFields';
import { PUSH_PAYMENTS } from '../apiUrls';

/**
 * @param {Object} responseData
 * @param {Object[]} responseData.items
 * @param {string} responseData.items[].uuid
 * @param {string} responseData.items[].contract
 * @param {string} responseData.items[].bankCode
 * @param {string} responseData.items[].rank
 * @param {string} responseData.items[].recipient
 * @param {string} responseData.items[].partner
 * @param {string} responseData.items[].legalName
 * @param {string} responseData.items[].eventType
 * @param {string} responseData.items[].application
 * @param {string} responseData.items[].extra1
 * @param {string} responseData.items[].extra2
 * @param {string} responseData.items[].label
 * @param {number} responseData.totalResults
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    const data = {};
    const mappedItems = items.map(item => ({
        [NotifRulesFields.UUID.key]: item[NotifRulesFields.UUID.key],
        [NotifRulesFields.CONTRACT.key]: item[NotifRulesFields.CONTRACT.key],
        [NotifRulesFields.BANK_CODE.key]: item[NotifRulesFields.BANK_CODE.key],
        [NotifRulesFields.RANK.key]: item[NotifRulesFields.RANK.key],
        [NotifRulesFields.RECIPIENT.key]: item[NotifRulesFields.RECIPIENT.key],
        [NotifRulesFields.PARTNER.key]: item[NotifRulesFields.PARTNER.key],
        [NotifRulesFields.LEGAL_NAME.key]: item[NotifRulesFields.LEGAL_NAME.key],
        [NotifRulesFields.EVENT_TYPE.key]: item[NotifRulesFields.EVENT_TYPE.key],
        [NotifRulesFields.APPLICATION.key]: item[NotifRulesFields.APPLICATION.key],
        [NotifRulesFields.EXTRA_1.key]: item[NotifRulesFields.EXTRA_1.key],
        [NotifRulesFields.EXTRA_2.key]: item[NotifRulesFields.EXTRA_2.key],
        [NotifRulesFields.LABEL.key]: item[NotifRulesFields.LABEL.key]
    }));

    data.items = mappedItems;
    data.totalResults = totalResults;
    return data;
}

const queryGetNotifRules = ({ query }, enabled) => {
    return {
        queryKey: [PUSH_PAYMENTS.NOTIF_RULES.COLLECTION.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(PUSH_PAYMENTS.NOTIF_RULES.COLLECTION.url, query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetNotifRules;